import { useYearInReviewStatsQuery } from "@/__generated__/graphql";
import { UserProfile } from "@/__generated__/graphql";
import { extractGraphQLErrorMessage } from "@/helpers";
import YearInReviewView from "../views/YearInReviewView";

const isYearInReviewAvailable = (): boolean => {
  const now = new Date();
  const month = now.getMonth(); // 0-11, где 0 = январь, 11 = декабрь
  // Декабрь (11), Январь (0), Февраль (1)
  return month === 11 || month === 0 || month === 1;
};

export default function YearInReview({ user }: { user: UserProfile }) {
  const { data, error, loading } = useYearInReviewStatsQuery();

  if (!isYearInReviewAvailable()) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>Функция "Итоги года" доступна с декабря по февраль</div>
    );
  }

  return (
    <YearInReviewView
      user={user}
      data={data?.yearInReviewStats}
      error={error && extractGraphQLErrorMessage(error)}
      loading={loading}
    />
  );
}
